module.exports = __webpack_public_path__ + "img/3d-model_cn.04dd1f2.jpg";